export default [
  {
    path: '/halal-templates',
    name: 'halal-templates',
    component: () => import('@/views/halal/templates/Templates.vue'),
    meta: {
      title: 'Templates Halal',
      requiresAuth: true,
      action: 'browes',
      resource: 'Templates Halal',
      pageTitle: 'Halal',
      breadcrumb: [
        {
          text: 'Templates Halal',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/halal-templates/edit/:id',
    name: 'edit-halal-templates',
    component: () => import('@/views/halal/templates/control-templates/EditTemplates.vue'),
    meta: {
      title: 'Edit Templates Halal',
      requiresAuth: true,
      pageTitle: 'Templates Halal',
      breadcrumb: [
        {
          text: 'Templates Halal',
          to: '/halal-templates',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
